<template>
    <module-card :nextDisabled="nextDisabled">
        <FlipCard :flipped="flipped">
            <template v-slot:front>
                <p>
                    Now that you know more about yourself, take a minute to learn more about four peeps you’ll be seeing more of through MyPEEPS!
                </p>

                <v-container grid-list-xs>
                    <v-row wrap justify-center no-gutters>
                        <v-col v-for="peep in peeps" :key="peep.id" cols="6">
                            <a @click.prevent="select(peep)">
                                <v-img :src="peep.image" alt="peep.name" :class="{ completed: peep.complete }">
                                    <v-img v-if="peep.complete" :src="require('@/assets/underwearPersonality/profiles/checkmark.png')" class="check"></v-img>
                                </v-img>
                            </a>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:back>
                <div v-if="selectedPeep">
                    <v-card>
                        <v-card-text class="text--primary">
                            <v-img :src="peeps[selectedPeep].profileImage"></v-img>

                            <p v-html="peeps[selectedPeep].blurb"></p>

                            <p v-if="!gossip">Click the view gossip botton below to learn a little more about him.</p>
                            <p v-else v-html="peeps[selectedPeep].gossip"></p>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <a v-if="!gossip" @click.prevent="gossip = !gossip">
                                <v-img max-width="200" :src="require('@/assets/underwearPersonality/profiles/gossipStamp.png')" alt="Gossip"></v-img>
                            </a>
                            <div v-else class="text-xs-center">
                                <v-btn rounded large color="primary" @click="done(peeps[selectedPeep])">Done</v-btn>
                            </div>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </div>
            </template>
        </FlipCard>
        <template v-if="flipped" v-slot:actions>
            <v-spacer></v-spacer>
        </template>
    </module-card>
</template>

<script>
    import { keyBy, every } from 'lodash';
    export default {
        data() {
            return {
                flipped: false,
                selectedPeep: null,
                gossip: false
            };
        },
        methods: {
            select(peep) {
                this.selectedPeep = peep.id;
                this.gossip = false;
                this.flipped = true;
            },
            done(peep) {
                peep.complete = true;
                this.flipped = false;
                this.gossip = false;
            },
            nextDisabled() {
                // disable next until all peeps have been visited (including viewing gossip)
                return !every(this.peeps, (p) => {
                    return p.complete;
                });
            }
        },
        computed: {
            peeps() {
                let peeps = keyBy(
                    [
                        {
                            id: 1,
                            name: 'Philip',
                            image: require('@/assets/underwearPersonality/profiles/characters_Philip.png'),
                            profileImage: require('@/assets/underwearPersonality/profiles/pProfile.png'),
                            blurb: `Here’s more about Philip aka "P."
                                <p/>
                                <p/>
                                When it comes to underwear personality, P’s a TOTAL <span class="font-weight-bold">tighty-whiteys</span> guy (but he thinks of himself as a jock-strap guy).
                                <p/>
                                P’s only attracted to cisgender men. He likes the “bad boys” type and he typically likes them a little older, too.
                                <p/>
                                P identifies his gender as “male” and he’d describe himself as a “nerdy masculine” guy. He loves Pokemon, and his favorite is Squirtle.
                                <p/>
                                He is currently “talking to” Rodney.
                                <p/>
                                You’ll be spending a lot of time with P throughout MyPEEPS but you’ll also get to meet the other peeps he knows.`,
                            gossip: `<span style="font-weight:bold">Gossip: </span>He’s pretty straight-laced and people call him “preppy.” He recently came out as gay to his close friends, these days he’s experimenting more with guys. Philip isn't out to his family and most of his friends because he knows they will not accept him. One of his best friends is Nico.`,
                            complete: false
                        },
                        {
                            id: 2,
                            name: 'Art',
                            image: require('@/assets/underwearPersonality/profiles/characters_Art.png'),
                            profileImage: require('@/assets/underwearPersonality/profiles/artProfile.png'),
                            blurb: `Here’s more about Art, who is someone P’s known since they met in Junior High.
                                <p/>
                                <p/>
                                When it comes to underwear personality, he goes <span class="font-weight-bold">Commando</span>.
                                <p/>
                                Art’s gender is “male” and he describes himself as “outdoorsy” because he likes camping and fishing.
                                <p/>
                                He’s in an on-and-off-again relationship with a girl (Julie), and she doesn’t know that when he says he’s with “the guys,” he’s really “with” guys. Yeah, it’s complicated.
                                <p/>
                                He uses the pull out method when having sex with Julie and only uses condoms with guys, since he believes that “only gay people get HIV.”`,
                            gossip: `<span style="font-weight:bold">Gossip: </span>Art and P dated for a whole day in 9th grade. They ended things because they realized they’re better friends than boyfriends. Art is “bi” and goes online mainly looking for hook-ups and he’s pretty open about it – <span class="font-italic">what a total Commando way to be!</span>`,
                            complete: false
                        },
                        {
                            id: 3,
                            name: 'Nico',
                            image: require('@/assets/underwearPersonality/profiles/characters_Nico.png'),
                            profileImage: require('@/assets/underwearPersonality/profiles/nicoProfile.png'),
                            blurb: `Here’s more about Nico.
                                <p/>
                                <p/>
                                His underwear personality is <span class="font-weight-bold">Boxers</span>!
                                <p/>
                                Nico’s attracted to mostly guys (including trans* guys), although on occasion he finds some girls super hot! He identifies as pansexual or just “pan.”
                                <p/>
                                He is currently single, and he meets hook-ups on Snapchat, Grindr and Instagram.
                                <p/>
                                Nico is American Indian and he describes his gender identity as “two-spirit – a mix of masc and fem.”`,
                            gossip: `<span style="font-weight:bold">Gossip: </span>Nico is completely out and proud, but he’s still learning how to relate to White LGBTQ peeps without having to down play his Native side. Because he “walks in both worlds,” he meets all types of guys. He is attracted to white, preppy, frat-types which makes some of his family angry because they want him to be with another Native or person of color (POC).`,
                            complete: false
                        },
                        {
                            id: 4,
                            name: 'Tommy',
                            image: require('@/assets/underwearPersonality/profiles/characters_Tommy.png'),
                            profileImage: require('@/assets/underwearPersonality/profiles/tommyProfile.png'),
                            blurb: `Here’s more about Tommy – when it comes to underwear personality, Tommy’s a <span class="font-weight-bold">thong</span> boy.
                                <p/>
                                <p/>
                                For Tommy, attraction isn’t the other person’s body parts or gender. He’s all about “a great connection of souls.” He prefers not to use a label for his sexuality.
                                <p/>
                                When it comes to his gender, Tommy says he’s “non-conforming male,” and he describes it as acting masculine one day and maybe feminine the next.
                                <p/>
                                Right now he’s in an open relationship with an older guy. They agree that it’s okay to hook up with other guys as long as they always practice safer sex with those guys, get tested regularly, and take PrEP (We’ll talk more about PrEP later!).`,
                            gossip: `<span style="font-weight:bold">Gossip: </span>Tommy’s popular, SUPER sweet, and friends with everyone! He works in an HIV/STI clinic and knows A LOT about sexual health. Because of where he works and being in an open relationship, people think Tommy’s had a lot of experience with sex.
                                <p/>
                                Truth is: he’s only been with three guys so far.`,
                            complete: false
                        }
                    ],
                    'id'
                );

                return peeps;
            }
        }
    };
</script>

<style scoped>
    .check {
        transform: translate(-38%, -38.5%) scale(0.18);
    }
    .completed {
        opacity: 0.5;
    }
</style>
